<template>
  <div>

    <div v-if="!demoMode && !loading && companies.length > 1" class="content-header-minimum barometers clear">
      <div class="clear">
        <v-container grid-list-md class="pa-0" fluid>
          <v-layout row wrap>
            <v-flex md3 xs12>
              <v-select
                v-if="!loading && companies.length > 1"
                :items="filteredCompanies"
                :item-color="companyPrimaryColor"
                :background-color="$vuetify.theme.themes[theme].menu"
                item-text="name"
                item-value="id"
                v-on:input="loadActiveCompData()"
                v-model="activeComp"
                no-data-text="Geen bedrijven gevonden."
                label="Selecteer bedrijf"
                outlined
                hide-details
                dense>
                <template v-slot:prepend-item>
                  <v-list-item>
                    <v-list-item-content  class="pt-0" >
                      <v-text-field
                        :color="companyPrimaryColor"
                        placeholder="Zoeken"
                        prepend-inner-icon="search"
                        clearable
                        v-model="searchCompanies"
                        hide-details
                        dense
                      ></v-text-field>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider></v-divider>
                  <div v-if="searchCompanies && searchCompanies.length > 0" style="padding: 4px 17px 3px 17px; background-color:rgba(0,0,0, 0.02); color: rgba(0, 0, 0, 0.6); text-align: center; font-size: 12px">{{ filteredCompanies.length }} van {{ companies.length }} bedrijven</div>
                  <v-divider v-if="searchCompanies && searchCompanies.length > 0"></v-divider>
                </template>
              </v-select>
            </v-flex>
          </v-layout>
        </v-container>
      </div>
    </div>

    <v-card outlined v-if="!loading" class="mt-4">
      <v-container grid-list-md fluid class="ma-0 pa-1">

        <v-layout row wrap class="ma-0 pa-0">
          <v-flex xs6>
            <v-btn :color="filterPeriod == 'month' ? 'primary' : '#e8e9ee'" :dark="filterPeriod == 'month'" depressed :disabled="conversionPackage.type == 'inactive'" :loading="periodSelected.loading" @click="filterConversionMonth()" style="margin: 0; height: 48px;" block large><span>Selecteer maand</span></v-btn>
          </v-flex>
          <v-flex xs6>
            <v-btn :color="filterPeriod == 'week' ? 'primary' : '#e8e9ee'" :dark="filterPeriod == 'week'" depressed :disabled="conversionPackage.type == 'inactive'" :loading="periodSelected.loading" @click="filterConversionWeek()" style="margin: 0; height: 48px;" block large><span>Selecteer week</span></v-btn>
          </v-flex>  
        </v-layout>
        <v-layout v-if="filterPeriod == 'month'" row wrap class="ma-0 pa-0">
          <v-flex md3 xs12>
            <v-select
              single-line
              :color="companyPrimaryColor"
              :item-color="companyPrimaryColor"
              :items="activeYears"
              label="Selecteer jaar"
              hide-details
              outlined
              v-model="filterYear"      
            ></v-select>
          </v-flex>
          <v-flex md6 xs12>
            <v-select
              :color="companyPrimaryColor"
              :item-color="companyPrimaryColor"
              :items="months"
              item-text="name"
              item-value="id"
              item-disabled="disabled"
              label="Selecteer maand"
              hide-details
              v-model="filterNumber"
              outlined 
            ></v-select>
          </v-flex>
          <v-flex md3 xs12>
            <v-btn @click="loadConversions()" :disabled="filterButtonDisabled" :depressed="filterButtonDisabled" :loading="periodSelected.loading" :color="companySecondaryColor" style="margin: 0; height: 55px;" large block><span style="color:#fff;">Filter</span></v-btn>
          </v-flex>
        </v-layout>
        <v-layout v-if="filterPeriod == 'week'" row wrap class="ma-0 pa-0">
          <v-flex md3 xs12>
            <v-select
              single-line
              :color="companyPrimaryColor"
              :item-color="companyPrimaryColor"
              :items="activeYears"
              label="Selecteer jaar"
              hide-details
              outlined
              v-model="selectedPeriodYear"      
            ></v-select>
          </v-flex>
          <v-flex md6 xs12>
            <v-select
              :color="companyPrimaryColor"
              :item-color="companyPrimaryColor"
              :items="weeks"
              item-text="name"
              item-value="id"
              item-disabled="disabled"
              label="Selecteer week"
              hide-details
              v-model="filterNumber"
              outlined 
            ></v-select>
          </v-flex>
          <v-flex md3 xs12>
            <v-btn @click="loadConversions()" :disabled="filterButtonDisabled" :depressed="filterButtonDisabled" :loading="periodSelected.loading" :color="companySecondaryColor" style="margin: 0; height: 55px;" large block><span style="color:#fff;">Filter</span></v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
    
    <div v-if="loading" class="blackbox-loader"></div>

    <div v-if="!loading && dataLoading">
      <div class="loading-dots">
        <div class="loading-dots-loader"></div>
        <p class="loading-dots-text"></p>
      </div>
    </div>

    <v-container v-if="!loading && !dataLoading" grid-list-md fluid class="ma-0 pa-1">
      <v-layout row wrap class="ma-0 pa-0">
        <v-flex xs12 md3>
          <v-select
            v-if="!loading && branches.length > 2"
            :items="branches"
            :item-color="companyPrimaryColor"
            background-color="background"
            item-text="branchName"
            item-value="id"
            v-model="activeBranch"
            no-data-text="Geen vestigingen gevonden."
            label="Selecteer vestiging"
            outlined
            return-object
            hide-details
            @change="setReportData()"
            dense>
          </v-select>
        </v-flex>
      </v-layout>

      <v-layout row wrap class="ma-0 pa-0">
        <v-flex d-flex md4 sm6 xs12>
          <v-card outlined style="width: 100%">
            <v-list-item two-line>
              <v-list-item-content class="pb-0">
                <v-list-item-title >
                  <span style="font-size: 55px;"><strong>€ {{totalRevenue.toFixed(0) }}</strong></span>
                </v-list-item-title>
              </v-list-item-content>

              <v-list-item-avatar
                class="mb-0"
                size="80"
                color="background"
              >
                <v-icon size="45" color="primary"> mdi-cash-check</v-icon>
              </v-list-item-avatar>
            </v-list-item>
            <div class="px-4 pb-4">
              <div><strong>Opbrengst</strong></div>
              <div style="font-size: 14px; padding: 5px 0 0 0;">Van de gemaakte afspraken</div> 
              <!-- <div v-if="outgoingCalls.number > 0" style="font-size: 14px; padding: 5px 0 0 0;">Gemiddelde gesprekstijd: {{outgoingCalls.average}} </div>  -->
            </div>
          </v-card>
        </v-flex>

        <v-flex d-flex md4 sm6 xs12 v-if="openValue">
          <v-card outlined style="width: 100%">
            <v-list-item two-line>
              <v-list-item-content class="pb-0">
                <v-list-item-title >
                  <span style="font-size: 55px;"><strong>€ {{ openValue.toFixed(0) }}</strong></span>
                </v-list-item-title>
              </v-list-item-content>

              <v-list-item-avatar
                class="mb-0"
                size="80"
                color="background"
              >
                <v-icon size="45" color="secondary"> mdi-cash-off</v-icon>
              </v-list-item-avatar>
            </v-list-item>
            <div class="px-4 pb-4">
              <div><strong>Openstaande waarde</strong></div>
              <div style="font-size: 14px; padding: 5px 0 0 0;">Van de niet gemaakte afspraken</div> 
              <!-- <div v-if="outgoingCalls.number > 0" style="font-size: 14px; padding: 5px 0 0 0;">Gemiddelde gesprekstijd: {{outgoingCalls.average}} </div>  -->
            </div>
          </v-card>
        </v-flex>

        <v-flex d-flex md4 sm6 xs12 v-if="tags && tags.length > 0">
          <v-card outlined style="width: 100%">
            <div class="pa-3">
              <h3 style="font-size: 18px; padding: 2px 0 8px 0;"><strong>Conversie bronnen</strong></h3> 
              <v-chip block style="width: 100%;" v-for="(tag, index) in intentions.sourcesArray" small :color="tag.color" class="mr-2 mb-1" :key="index" :style="{color: tag.textColor }">
                <strong>{{ tag.name }}</strong> <span style="font-size: 12px; font-weight: bold;" :style="{color: tag.textColor }">&nbsp; | {{ tag.number }} afspraken | &euro; {{ tag.value.toFixed(0) }} </span>
              </v-chip><br>
            </div>
          </v-card>
        </v-flex>

        <v-flex d-flex md8 sm6 xs12>
          <v-card outlined style="width: 100%">
            <v-list-item two-line>
              <v-list-item-content class="pb-0">
                <v-list-item-title >
                  <span style="font-size: 55px;"><strong>{{ intentions.success }}</strong></span> <span v-if="intentions.open" style="font-size: 14px;"> (en {{intentions.open}} niet afgemaakte intenties)</span>
                </v-list-item-title>
              </v-list-item-content>

              <v-list-item-avatar
                class="mb-0"
                size="80"
                color="background"
              >
                <v-icon size="45" color="primary">mdi-cursor-default</v-icon>
              </v-list-item-avatar>
            </v-list-item>
            <div class="px-4 pb-4">
              <div class="pb-4"><strong>Conversies</strong></div>

              <div class="unanswered-days-wrapper" v-for="(day, index) in intentions.week" :key="index">
                <div class="unanswered-days">
                  <div class="unanswered-label"> {{ weekDay[index] }}: </div>
                  <div class="unanswered-number"><span v-if="day">({{ day }})</span></div>
                  <div class="unanswered-data-wrapper" v-if="day">
                    <div class="unanswered-data" :style="{width : ((day / intentions.total)*100).toFixed(0) +'%'}"></div>
                    <div class="unanswered-data-number"  :class="[{'medium': (((day / intentions.success)*100).toFixed(0) > 44 && ((day / intentions.success)*100).toFixed(0) < 60)},{'large' : ((day / intentions.success)*100).toFixed(0) > 59 }]">{{ ((day / intentions.success)*100).toFixed(1) }}%</div>
                  </div>
                  <div v-else class="unanswered-data-wrapper empty">-</div>
                  <div class="expand-hours text-center" v-if="day" @click="expandDayHoursIncoming(index)"></div>
                </div>

              </div>
            </div>
          </v-card>
        </v-flex>
        


      </v-layout>
    </v-container>


  </div>
</template>


<script>

import { bus } from "../main";
import moment from "moment";
import db from "../firebase/init";
import platform from 'platform'; 
import lodash from 'lodash';
import axios from 'axios';
import slugify from "slugify";


export default {
  name: "WidgetReport",
  props: ["urlStart", "urlEnd"],

  data: () => ({
    filterPeriod: 'month',
    filterYear: Number(moment().format('YYYY')),
    filterNumber: Number(moment().subtract(1, 'month').format('M')),
    loading: true,
    reportData: null,

    totalRevenue: 150,
    openValue: 100,
    tags: [
      {
        src: 'adw',
        name: 'Adwords',
        color: "red",
        number: 10
      },
      {
        src: 'test',
        name: 'test',
        color: "green",
        number: 5
      }
    ],
    weekDay: [
      "Zondag",
      "Maandag",
      "Dinsdag",
      "Woensdag",
      "Donderdag",
      "Vrijdag",
      "Zaterdag"
    ],

    weekHours: [
      "00:00 - 01:00u",
      "01:00 - 02:00u",
      "02:00 - 03:00u",
      "03:00 - 04:00u",
      "04:00 - 05:00u",
      "05:00 - 06:00u",
      "06:00 - 07:00u",
      "07:00 - 08:00u",
      "08:00 - 09:00u",
      "09:00 - 10:00u",
      "10:00 - 11:00u",
      "11:00 - 12:00u",
      "12:00 - 13:00u",
      "13:00 - 14:00u",
      "14:00 - 15:00u",
      "15:00 - 16:00u",
      "16:00 - 17:00u",
      "17:00 - 18:00u",
      "18:00 - 19:00u",
      "19:00 - 20:00u",
      "20:00 - 21:00u",
      "21:00 - 22:00u",
      "22:00 - 23:00u",
      "23:00 - 24:00u"
    ], 

    intentions: {
      total: 100,
      succes: 30,
      open: 60,
      week: { 
        0:{
            number: 10,
        },
      },
      sources: null
    },

    twoWeeksAgoUnix: moment().subtract(104, 'weeks').format('X'),
    expanded: [],
    
    feedback: null,
    liveUpdates: false,
    liveUpdatesTimer: null,
    filterToday: true,
    filterWeek: false,
    filterMonth: false,
    
    selectedPeriodDay: "01",
    selectedPeriodYear: moment().year(),
    selectedPeriodMonth: Number(moment().format("M")),
    activeCompData: {},
    conversions: [],
    activeCompDataOriginal: {},
    deleteCounter: 0,
    deleting: false,
    averageConversionTime: 300,
    companies: [],
    branches: [],
    activeBranch: {
      id: 'all',
      branchName: 'Alle'
    },
    branchNames: {},
    activeComp: "", 
    compStartYear: null,
    compStartMonth: null, 
    compStartWeek: null,
    dataLoading: false,
    toggle_exclusive: 1,
    today: null,
    selected: [],
    removeConversionsDialog: false,
    conversionPeriodType: 'day',
    conversionPeriodStart: null,
    conversionPeriodEnd: null,
    conversionPeriodStartFormatted: null,
    conversionPeriodEndFormatted: null,
    currentMonth: Number(moment().format("M")),
    selectedSources: [],
    filter: {
      selectedSources: [],
      active: false
    },
    collapsedClient: null,
    timer: null,
    futureAppointmentsTimer: null,
    checkForUpdates: null,
    conversionSelectedPage: 1,
    searchCompanies: "",
    closeConversionReason: null,
    closeConversionReasonOther: null,
    closeConversionReasonOtherWait: null,
    conversionTableLabels: [],
    appointmentDateDialog: false,
    conversionSalonhubfeedback: null,
    closeConversionSuccessfull: true,
    conversionSalonhubfeedback: null,
    conversionsClustered: [],
    conversionPages: 20,
    pricePerMessageSend: 0.1495,
    blacklisted: new Array(),
    tableOptions: {
      sortBy: "timestampUnix",
      itemsPerPage: 20,
      sortDesc: false
    },
    newBlacklist: {
      dialog: false,
      phone: null,
      comment: null
    },

    snackbar: true,
    conversieUpdates: [
      {
        show: true,
        company: "hbc",
        unix:1595928637
      },
      {
        show: true,
        company: "hogans",
        unix:1595928637
      },
      {
        show: true,
        company: "hogans",
        unix:1595928637
      }
    ],
    types: [
      {
        id: 'salonhub',
        name: 'Salonhub',
        color: 'white',
        outlined: false
      },
      {
        id: 'wordpressForm',
        name: 'Wordpress Formulier',
        color: 'black',
        outlined: true
      },
      {
        id: 'chatbotLandbot',
        name: 'Chatbot',
        color: 'red',
        outlined: true
      }
    ],
    updateCounter: 0,
    conversionKey: 0,
    sources: [],
    sourcesOriginal: [
      {
        query: 'nosource',
        name: 'Organisch',
        bgColor: {
          hex: '#cecece'
        },
        textColor: {
          hex: '#333'
        }
      },
      {
        query: 'unknown',
        name: 'Onbekend',
        bgColor: {
          hex: '#ccc'
        },
        textColor: {
          hex: '#333'
        }
      },
      {
        query: 'mc',
        name: 'Mailchimp',
        bgColor: {
          hex: '#ffe01b'
        },
        textColor: {
          hex: '#333'
        }
      },
      {
        query: 'adw',
        name: 'Adwords',
        bgColor: {
          hex: '#1a73e8'
        },
        textColor: {
          hex: '#fff'
        }
      }
    ],

    timeChecker: null,
    interval: null,
    updatesRunning: true,
    companiesLiveChecking: null 
  }),

  created() {
    this.loadUserComp();
    this.now = moment().format("YYYY-MM-DD")    
  },

  destroyed(){
    this.updatesRunning = false;
    this.checkForUpdates;
  },

  methods: {

    filterConversionMonth(){
      this.filterPeriod = 'month';
      this.filterYear = Number(moment().format('YYYY'));
      this.filterNumber = Number(moment().subtract(1, 'month').format('M'));
    },

    filterConversionWeek(){
      this.filterPeriod = 'week';
      this.filterYear = Number(moment().format('YYYY'));
      this.filterNumber = Number(moment().subtract(1, 'week').isoWeek());
    },

    expandDayHoursIncoming(dayIndex){
      for (const [key, value] of Object.entries(this.intentions.week)) {
        if(key == dayIndex){
          if(value.expanded){
            value.expanded = false;
          }
          else{
            value.expanded = true;
          }
        }
        else{
          value.expanded = false;
        }
      }
    },

    loadUserComp() {
      this.companiesLiveChecking = null;

      this.loaded = false;
      let userCompanies = this.userCompanies;
      this.companies = [];
      let counter = 0

      new Promise((resolve, reject)=>{
        if(this.userRole == 'superadmin'){
          db.collection("companies")
          .get()
          .then(snap => {
            this.companies = [];
            snap.forEach(doc => {
              let company = doc.data();
              company.id = doc.id;
              this.companies.push(company);
            });
          })
          .then(()=>{
            resolve();
          })
        }
        else{
          this.userCompanies.forEach(company=>{
          db.collection("companies").doc(company).get()
            .then(doc => {
              let company = {};
              company.name = doc.data().name;
              company.id = doc.id;
              this.companies.push(company);
              counter++
              if(counter == this.userCompanies.length){
                resolve()
              }
            })
          })
        }
      })
      .then(()=>{
        // REMEMBER SELECTED COMPANY FROM LOCAL STORAGE
        if(this.userRole == 'superadmin'){
          // Super Admins have access to multiple companies 
          let selectedCompany = window.localStorage.getItem('selectedCompany')

          // Check if a selected company is set in the Local Storage
          if(selectedCompany){
            
            // Check if the selected company is an option
            let selectedCompanyIndex = _.findIndex(this.companies, { 'id': selectedCompany })

            // Selected company is an option, set activeComp
            if(selectedCompanyIndex >= 0){
              this.activeComp = this.companies[selectedCompanyIndex].id;
              this.loadActiveCompData();
            } 
            // Selected company is no option, set first company as activeComp 
            else{
              this.activeComp = this.companies[0].id;
              window.localStorage.setItem('selectedCompany', this.companies[0].id)
              this.loadActiveCompData();
            }
          }
          // No selected company is set 
          else {
            this.activeComp = this.companies[0].id;
            window.localStorage.setItem('selectedCompany', this.companies[0].id)
            this.loadActiveCompData();
          }
        }

        // Regular users have 1 company, just get the first
        else {
          this.activeComp = this.companies[0].id;
          this.loadActiveCompData();
        }
        
      })
    },

    loadActiveCompData() {
      this.loading = true;
      this.sources = _.cloneDeep(this.sourcesOriginal)
      // Set Active Company as Selected Company in Local Storage
      window.localStorage.setItem('selectedCompany', this.activeComp)
      db.collection("companies")
        .doc(this.activeComp)
        .get()
        .then(doc => {
          if (doc.exists) {
            this.activeCompData = doc.data();
            this.activeCompData.id = doc.id;
            if(doc.data().conversion.start){
              this.compStartYear = moment.unix(doc.data().conversion.start.seconds).format("YYYY");
              this.compStartMonth = moment.unix(doc.data().conversion.start.seconds).format("M");
              this.compStartWeek = moment.unix(doc.data().conversion.start.seconds).isoWeek();
            } else {
              this.compStartYear = moment().year();
              this.compStartMonth = moment().month();
              this.compStartWeek = moment().isoWeek();
            }
          } else {
            console.log("No such document!");
          }
        })
        .then(() => {
          this.activeCompDataOriginal = _.cloneDeep(this.activeCompData);
          this.selectedLanguage = this.activeCompDataOriginal.languages[0];
          this.loadBranches();
        })
        .then(()=>{
          this.conversionSelectedPage = 1;
          if(this.activeCompData.conversion.sources.length > 0){
            this.activeCompData.conversion.sources.forEach(sourceItem=>{
              this.sources.push(sourceItem)
            })
          }
        })
        .then(() => {
          this.loading = false;
          this.dataLoading = true;
          this.loadConversions();
        })
        .catch(error => {
          this.loading = false;
          console.error("Error getting document:", error);
        });
    },

    async loadConversions(){

      this.dataLoading = true;
      this.reportData = null;

      var data = {
        "companyId": this.activeComp,
        "type": this.filterPeriod,
        "year": this.filterYear,
        "number": this.filterNumber
      }

      var config = {
        method: 'post',
        // url: 'http://localhost:8888/report',
        url: '	https://chatsend.hogans.nl/report',
        headers: { 
          'Content-Type': 'application/json'
        },
        data : data
      };

      await axios(config)
      .then((response)=> {
        this.reportData = response.data;
        console.log("report response: ", response.data)
        this.setReportData()
      })
      .catch(error=> {
        console.error(error);
      });

    },

    async setReportData(){
      if(this.activeBranch.id == 'all'){
        this.totalRevenue = this.reportData.convertedValue;
        this.openValue = this.reportData.openValue;
        this.intentions.total = this.reportData.attempts;
        this.intentions.success = this.reportData.conversions;
        this.intentions.open = this.reportData.attempts - this.reportData.conversions;
        this.intentions.week = this.reportData.conversionDays;
        this.intentions.sources = this.reportData.sources;
        this.intentions.sourcesArray = new Array();
        await this.setSourceData(this.reportData.sources)
      }
      else{
        this.totalRevenue = this.reportData.branchData[this.activeBranch.branchNameSalonhub].convertedValue;
        this.openValue = this.reportData.branchData[this.activeBranch.branchNameSalonhub].openValue;
        this.intentions.total = this.reportData.branchData[this.activeBranch.branchNameSalonhub].attempts;
        this.intentions.success = this.reportData.branchData[this.activeBranch.branchNameSalonhub].conversions;
        this.intentions.open = this.reportData.branchData[this.activeBranch.branchNameSalonhub].attempts - this.reportData.branchData[this.activeBranch.branchNameSalonhub].conversions;
        this.intentions.week = this.reportData.branchData[this.activeBranch.branchNameSalonhub].conversionDays;
        this.intentions.sources = this.reportData.branchData[this.activeBranch.branchNameSalonhub].sources;
        this.intentions.sourcesArray = new Array();
        await this.setSourceData(this.reportData.branchData[this.activeBranch.branchNameSalonhub].sources)
      }
      this.dataLoading = false;
    },

    setSourceData(reportSources){
      for (const [key, value] of Object.entries(reportSources)) {
        this.sources.forEach((source)=>{
          if(source.query == key){
            let sourceData = {
              name: source.name,
              color: source.bgColor.hex,
              textColor: source.textColor.hex,
              number: value.number,
              value: value.value
            }
            this.intentions.sourcesArray.push(sourceData);
          }
        })
      }
      this.intentions.sourcesArray = this.intentions.sourcesArray.sort((a,b) => {return (a.number > b.number) ? -1 : 1});
      return
    },

    loadBranches(){
      this.branchNames = {};
      this.branches = [
        {
          id: 'all',
          branchName: 'Alle'
        }
      ];
      db.collection("branches")
        .where('compId', '==', this.activeCompData.id)
        .get()
        .then(snap => {
          snap.forEach(doc => {
            let branch = doc.data();
            branch.id = doc.id;
            this.branchNames[branch.branchNameSalonhub] = branch.branchName;
            this.branches.push(branch);
          })
        })
    },



  },

  computed: {

    updateCompany(){
      return id => _.find(this.companies, ['id', id]);
    },

    conversieUpdatesFiltered(){
      let index = this.updateCounter; 
      let unixNow = Number(moment().format('X'));
      let timeout = 25;
      let updates = [];
      this.conversieUpdates.forEach(update=>{
        if((update.unix > (unixNow - timeout)) && update.show == true){
          updates.push(update);
        }
      })
      return updates;
    },

    conversionSelectorPages(){
      return Math.ceil(this.conversionsFiltered.length / 50)
    },

    conversionPackage(){
      let packageStatus = { 
        type: 'inactive',
        days: 0
      }

      if(this.activeCompData.packages && this.activeCompData.packages.length > 0 && _.indexOf(this.activeCompData.packages, 'conversion') >= 0){
        packageStatus.type = 'active';
      }
      else{
        // Package not purchased, check for active trial
        if(this.activeCompData.trials && this.activeCompData.trials.length > 0){
          this.activeCompData.trials.forEach(trailPackage =>{
            if(trailPackage.id == 'conversion'){
              // Trial found, check if trialperiod is still active
              if(moment(trailPackage.trialStartDate).add(trailPackage.trialDays, 'days') > moment()){
                packageStatus.type = 'trial';
                packageStatus.days = moment(trailPackage.trialStartDate).add(trailPackage.trialDays, 'days').diff(moment(), 'days')
              }
            }
          })
        }
      }
      return packageStatus
    },

    liveUpdatesActive(){
      if(this.liveUpdates){
        return true
      }
      else {
        return false
      }
    },

    conversionTableValues(){
      let data = Array.apply(null, Array(this.conversionTableLabels.length))

      this.conversionTableLabels.forEach((day, index) =>{
        data[index] = 0
        let dayDate = moment(this.conversionPeriodStart).add(index, 'days').format('YYYY-MM-DD')
          this.conversionsFiltered.forEach(conversion =>{
            if(moment.unix(conversion.timestamp.seconds).format('YYYY-MM-DD') == dayDate){
              data[index]++
            }
          })
      })
      return data
    },

    chooseAllSources () {
      return this.selectedSources.length === this.sources.length
    },

    selectSomeSources () {
      return this.selectedSources.length > 0 && !this.chooseAllSources
    },

    icon () {
      if(this.chooseAllSources) return 'check_box'
      if(this.selectSomeSources) return 'indeterminate_check_box'
      return 'check_box_outline_blank'
    },

    activeYears(){
      let currentYear = Number(moment().year())
      let startDateCompany = moment().format("YYYY-MM-DD")

      if(this.activeCompData.conversion.start){
        startDateCompany = moment.unix(this.activeCompData.conversion.start.seconds).format("YYYY-MM-DD")
      }

      let numberOfYears = moment().diff(startDateCompany, 'years', false) + 1;
      // console.log("numberOfYears: ", numberOfYears)
      let activeYears = Array.apply(null, Array(numberOfYears))
      let counter = 0

      activeYears.forEach((year, index)=>{
        activeYears[index] = currentYear - counter
        counter++
      })
      return activeYears
    },

    months(){
      let months = [
        { id: 1, name: "Januari", disabled: false },
        { id: 2, name: "Februari", disabled: false },
        { id: 3, name: "Maart", disabled: false },
        { id: 4, name: "April", disabled: false },
        { id: 5, name: "Mei", disabled: false },
        { id: 6, name: "Juni", disabled: false },
        { id: 7, name: "Juli", disabled: false },
        { id: 8, name: "Augustus", disabled: false },
        { id: 9, name: "September", disabled: false },
        { id: 10, name: "Oktober", disabled: false },
        { id: 11, name: "November", disabled: false },
        { id: 12, name: "December", disabled: false },  
      ]

      if(this.selectedPeriodYear == moment().year()){
        months.forEach(month=>{
          if(month.id > Number(this.currentMonth)){
            month.disabled = true
          } 
          else{
            if(this.selectedPeriodYear == moment.unix(this.activeCompData.conversion.start.seconds).format("YYYY")){
              if(this.activeCompData.conversion.start && (month.id < Number(moment.unix(this.activeCompData.conversion.start.seconds).format("M")))){
                month.disabled = true
              } 
            }
          }
        })
        return months
      }
      else if(this.selectedPeriodYear == this.compStartYear){
        months.forEach(month=>{
          if(month.id < this.compStartMonth){
            month.disabled = true
          } 
        })
        return months
      } else{
        return months
      }
    },

    weeks(){
      let weeks = [
        { id: 1, name: "Week 1", disabled: false },
        { id: 2, name: "Week 2", disabled: false },
        { id: 3, name: "Week 3", disabled: false },
        { id: 4, name: "Week 4", disabled: false },
        { id: 5, name: "Week 5", disabled: false },
        { id: 6, name: "Week 6", disabled: false },
        { id: 7, name: "Week 7", disabled: false },
        { id: 8, name: "Week 8", disabled: false },
        { id: 9, name: "Week 9", disabled: false },
        { id: 10, name: "Week 10", disabled: false },
        { id: 11, name: "Week 11", disabled: false },
        { id: 12, name: "Week 12", disabled: false },  
        { id: 13, name: "Week 13", disabled: false },  
        { id: 14, name: "Week 14", disabled: false },  
        { id: 15, name: "Week 15", disabled: false },  
        { id: 16, name: "Week 16", disabled: false },  
        { id: 17, name: "Week 17", disabled: false },  
        { id: 18, name: "Week 18", disabled: false },  
        { id: 19, name: "Week 19", disabled: false },  
        { id: 20, name: "Week 20", disabled: false },  
        { id: 21, name: "Week 21", disabled: false },  
        { id: 22, name: "Week 22", disabled: false },  
        { id: 23, name: "Week 23", disabled: false },  
        { id: 24, name: "Week 24", disabled: false },  
        { id: 25, name: "Week 25", disabled: false },  
        { id: 26, name: "Week 26", disabled: false },  
        { id: 27, name: "Week 27", disabled: false },  
        { id: 28, name: "Week 28", disabled: false },  
        { id: 29, name: "Week 29", disabled: false },  
        { id: 30, name: "Week 30", disabled: false },  
        { id: 31, name: "Week 31", disabled: false },  
        { id: 32, name: "Week 32", disabled: false },  
        { id: 33, name: "Week 33", disabled: false },  
        { id: 34, name: "Week 34", disabled: false },  
        { id: 35, name: "Week 35", disabled: false },  
        { id: 36, name: "Week 36", disabled: false },  
        { id: 37, name: "Week 37", disabled: false },  
        { id: 38, name: "Week 38", disabled: false },  
        { id: 39, name: "Week 39", disabled: false },  
        { id: 40, name: "Week 40", disabled: false },  
        { id: 41, name: "Week 41", disabled: false },  
        { id: 42, name: "Week 42", disabled: false },  
        { id: 43, name: "Week 43", disabled: false },  
        { id: 44, name: "Week 44", disabled: false },  
        { id: 45, name: "Week 45", disabled: false },  
        { id: 46, name: "Week 46", disabled: false },  
        { id: 47, name: "Week 47", disabled: false },  
        { id: 48, name: "Week 48", disabled: false },  
        { id: 49, name: "Week 49", disabled: false },  
        { id: 50, name: "Week 50", disabled: false },  
        { id: 51, name: "Week 51", disabled: false },  
        { id: 52, name: "Week 52", disabled: false }  
      ]

      if(this.selectedPeriodYear == moment().year()){
        weeks.forEach(week=>{
          if(week.id > Number(moment().isoWeek())){
            week.disabled = true;
          } 
          else{
            if(this.selectedPeriodYear == moment.unix(this.activeCompData.conversion.start.seconds).format("YYYY")){
              if(this.activeCompData.conversion.start && (week.id < Number(moment.unix(this.activeCompData.conversion.start.seconds).isoWeek()))){
                week.disabled = true;
              } 
            }
          }
        })
        return weeks;
      }
      else if(this.selectedPeriodYear == this.compStartYear){
        weeks.forEach(week=>{
          if(week.id < this.compStartMonth){
            week.disabled = true
          } 
        })
        return weeks;
      } else{
        return weeks;
      }
    },

    filterButtonDisabled(){
      if((this.selectedPeriodYear == moment().year() && this.currentMonth < this.selectedPeriodMonth) || this.selectedPeriodYear == this.compStartYear && this.selectedPeriodMonth < this.compStartMonth){
        return true
      } else {
        return false
      }
    },

    todaySelected(){
      let data = {
        color: this.$vuetify.theme.themes[this.theme].menuborder,
        textColor: this.$vuetify.theme.themes[this.theme].text,
        loading: false
      }
      if(this.filterToday && this.dataLoading){
        data.color = this.companyPrimaryColor;
        data.textColor = "#fff";
        data.loading = true
      } else if(this.filterToday){
        data.color = this.companyPrimaryColor;
        data.textColor = "#fff";
      } 
      return data
    },

    weekSelected(){
      let data = {
        color: this.$vuetify.theme.themes[this.theme].menuborder,
        textColor: this.$vuetify.theme.themes[this.theme].text,
        loading: false
      }
      if(this.filterWeek && this.dataLoading){
        data.color = this.companyPrimaryColor;
        data.textColor = "#fff";
        data.loading = true
      } else if(this.filterWeek){
        data.color = this.companyPrimaryColor;
        data.textColor = "#fff";
      } 
      return data
    },

    monthSelected(){
      let data = {
        color: this.$vuetify.theme.themes[this.theme].menuborder,
        textColor: this.$vuetify.theme.themes[this.theme].text,
        loading: false
      }
      if(this.filterMonth && this.dataLoading){
        data.color = this.companyPrimaryColor;
        data.textColor = "#fff";
        data.loading = true
      } else if(this.filterMonth){
        data.color = this.companyPrimaryColor;
        data.textColor = "#fff";
      } 
      return data
    },
    
    periodSelected(){
      let data = {
        color: this.$vuetify.theme.themes[this.theme].menuborder,
        textColor: this.$vuetify.theme.themes[this.theme].text,
        loading: false
      }
      if(this.filterPeriod && this.dataLoading){
        data.color = this.companyPrimaryColor
        data.textColor = "#fff";
        data.loading = true
      } else if(this.filterPeriod){
        data.color = this.companyPrimaryColor
        data.textColor = "#fff";
      } 
      return data
    },

    randomHipster(){
      if(this.conversionsFiltered.length == 0){
        let randomNumber = Math.floor(Math.random() * 12) + 1;
        let hipsterClass = "hipster-" + randomNumber
         return hipsterClass
      } else {
        return null
      }    
    },

    userCompanies() {
      return this.$store.state.userCompanies;
    },
    userCompany() {
      return this.$store.state.userCompany;
    },
    userFirstName() {
      return this.$store.state.userFirstName;
    },
    userLastName() {
      return this.$store.state.userLastName;
    },
    userRole() {
      return this.$store.state.userRole;
    },
    userOperator() {
      return this.$store.state.userOperator;
    },
    companyPrimaryColor() {
      return this.$store.state.companyPrimaryColor;
    },
    companySecondaryColor() {
      return this.$store.state.companySecondaryColor;
    },
    theme(){
      return (this.$vuetify.theme.dark) ? 'dark' : 'light'
    },
    demoMode(){
      return this.$store.state.demoMode;
    },
    filteredCompanies(){
      if(this.searchCompanies && this.searchCompanies.length > 0){
        return this.companies.filter(company => {
          return company.name.toLowerCase().includes(this.searchCompanies.toLowerCase());
        });
      } else {
        return this.companies
      }
    },
    adminUser(){
      if(this.userRole == 'superadmin'){
        return true
      } else {
        return false
      }
    },
    changed() {
      if (_.isEqual(this.activeCompData, this.activeCompDataOriginal) == false) {
        return true;
      } else {
        return false;
      }
    }
  }
}
</script>

<style>

.unanswered-data{
  position:relative;
  height: 22px;
  background: #2580c3;
}

.unanswered-data.hours{
  height: 18px;
}

.extention-name{
  font-weight: 600;
  padding: 0 0 0 3px;
}

.v-list-item--disabled{
  opacity: 0.3;
  cursor: not-allowed;
}


.unanswered-hours-wrapper{
  margin: 5px 0 0 0;
  padding: 3px;
  background-color: var(--v-background-base);
}

.unanswered-days-wrapper{
  width: 100%;
  padding: 3px 0;
}

.unanswered-hour{
  margin: 2px 0;
}


.unanswered-hour:after,
.unanswered-days:after,
.unanswered-hours-wrapper:after,
.unanswered-days-wrapper:after{
  content: "";
  display: block;
  clear: both;
 }

.unanswered-label{
  width: 100px;
  float: left;
  font-weight: 600;
  font-size: 15px;
  overflow: hidden;
 }

.unanswered-label.hours{
  width: 97px;
  font-weight: 500;
  font-size: 13px;
}

.unanswered-number{
  width: 35px;
  float: left;
  height: 22px;
  line-height: 22px;
  font-weight: 400;
  font-size: 11px;
  overflow: hidden;
 }

.unanswered-data-wrapper{
  width: calc(100% - 175px);
  float: left;
  position:relative;
  height: 22px;
  background-color: var(--v-background-base);
 }

.unanswered-data-wrapper.hours{
  width: calc(100% - 172px);
  height: 18px;
  background-color: var(--v-menu-base);
}

.expand-hours{
  float: left;
  width: 30px;
  height: 21px;
}

.unanswered-data-wrapper.empty{
  background: none!important;
}

.unanswered-data-number{
  top: 0;
  height: 22px;
  font-weight: 600;
  font-size: 14px;
  width: 100%;
  position: absolute;
  line-height: 22px;
  text-align: center;
}
.unanswered-data-number.medium{
  color: #d3e1e8;
}

.unanswered-data-number.large{
  color: #ffffff;
}


.unanswered-data-number.hours{
  height: 18px;
  font-size: 12px;
  line-height: 18px;
}

.unanswered-data{
  position:relative;
  height: 22px;
  background: var(--v-primary-base);
}

.unanswered-data.hours{
  height: 18px;
}

</style>
